import {login, fetchAdminInfo} from "@/api/admin";
import {getToken, setToken, removeToken} from '@/utils/auth';

const user = {
  state: {
    token: getToken(),
    name: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },

    SET_NAME: (state, name) => {
      state.name = name;
    },

    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data;
          const token = data.tokenHead + data.token;
          setToken(token);
          commit('SET_TOKEN', token);
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },

    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        fetchAdminInfo().then(response => {
          const data = response.data;
          if (data.roles && data.roles.length > 0) {
            commit('SET_ROLES', data.roles);
          } else {
            reject('getUserInfo: roles must be a non-null array!');
          }
          commit('SET_NAME', data.username);
          resolve(response);
        }).catch(e => {
          reject(e);
        });
      });
    },

    // 前端登出
    FedLogout({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve();
      })
    }
  }
}

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js